function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "A7EAF473-1EF5-4150-B4DF-389E7B964393");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Responsive_1",
  transform: "translate(-17.000000, -2782.000000)",
  fill: "#22252D",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "Distribuidor-3",
  transform: "translate(17.000000, 2782.000000)"
}, React.createElement("g", {
  id: "placeholder"
}, React.createElement("path", {
  d: "M6.96256641,20.7091582 L1.10204883,11.2650234 C0.380994141,10.1005078 0,8.75823047 0,7.3828125 C0,3.31192969 3.31192969,0 7.3828125,0 C11.4536953,0 14.765625,3.31192969 14.765625,7.3828125 C14.765625,8.71741992 14.4055488,10.0253672 13.7242793,11.1652734 L8.01314063,20.700873 C7.90289063,20.8849512 7.70470313,20.9982773 7.49019141,21 C7.27260352,21 7.07482617,20.8900781 6.96256641,20.7091582 Z M7.3828125,2.21670508 C4.6258125,2.21670508 2.3828125,4.67374387 2.3828125,7.69383123 C2.3828125,8.7144024 2.6406125,9.70992485 3.1284125,10.5728278 L7.3828125,17.9603527 L11.6783792,10.4987771 C12.1391125,9.65420422 12.3828125,8.68413215 12.3828125,7.69383123 C12.3828125,4.67374387 10.1398125,2.21670508 7.3828125,2.21670508 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M7.191406,10.382812 C6.07806629,10.382812 5.06224176,9.81626651 4.47406563,8.86735513 C4.16382551,8.36573703 4,7.786355 4,7.191406 C4,5.43166473 5.43166473,4 7.191406,4 C8.95114727,4 10.382812,5.43166473 10.382812,7.191406 C10.382812,7.76883773 10.227816,8.33353929 9.93463222,8.82451937 C9.35138504,9.80034494 8.32591537,10.382812 7.191406,10.382812 Z M7.191406,6.191406 C6.640006,6.191406 6.191406,6.640006 6.191406,7.191406 C6.191406,7.37807267 6.242556,7.55943933 6.33932267,7.715906 C6.52382267,8.01357267 6.842406,8.191406 7.191406,8.191406 C7.54702267,8.191406 7.868556,8.008656 8.05152267,7.702556 C8.14302267,7.54933933 8.191406,7.372556 8.191406,7.191406 C8.191406,6.640006 7.742806,6.191406 7.191406,6.191406 Z",
  id: "Shape"
})))));

var SvgMarker = function SvgMarker(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "15px",
    height: "21px",
    viewBox: "0 0 15 21",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/marker.5805bb6f.svg";
export { ForwardRef as ReactComponent };